import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isEmpty } from 'lodash';

import { CustomerReferral } from './customer-referral.types';
import ACResponse from '../../common/response';

@Injectable()
export class CustomerReferralService {
  private referralAPIURL = 'referral-api';
  constructor(private http: HttpClient) {}

  readActviceReferral(customerId: number): Promise<CustomerReferral> {
    return this.http
      .get<ACResponse<CustomerReferral>>(
        `${this.referralAPIURL}/api/v1/referrals?status=active&hq-customer-id=${customerId}`
      )
      .toPromise()
      .then(response => {
        if (!isEmpty(response.data)) return response.data[0];
        else return {};
      })
      .catch(err => {
        console.error(
          'Error getting Referral for CustomerId:',
          customElements,
          'Error:',
          err
        );
        return undefined;
      });
  }
}
